"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/organisms/toast/toaster.tsx
import { G } from "@mobily/ts-belt";
import { Fragment } from "react";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport
} from "./toast.js";
import { useToast } from "./use-toast.js";
import { jsx, jsxs } from "react/jsx-runtime";
function Toaster() {
  const { toasts } = useToast();
  return /* @__PURE__ */ jsx(ToastProvider, { children: toasts.map(({ id, title,
  description, action, viewportClassName, ...props }) => /* @__PURE__ */ jsxs(Fragment,
  { children: [
    /* @__PURE__ */ jsxs(Toast, { ...props, children: [
      /* @__PURE__ */ jsxs("div", { className: "grid gap-1", children: [
        G.isNotNullable(title) && /* @__PURE__ */ jsx(ToastTitle, { children: title }),
        G.isNotNullable(description) && /* @__PURE__ */ jsx(ToastDescription, { children: description })
      ] }),
      action,
      /* @__PURE__ */ jsx(ToastClose, {})
    ] }, id),
    /* @__PURE__ */ jsx(ToastViewport, { className: viewportClassName })
  ] }, id)) });
}
__name(Toaster, "Toaster");
export {
  Toaster
};
